import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//modules
import user from './modules/user'
import customer from './modules/customer'
import energetic from './modules/energetic'
import report from './modules/report'
import operation from './modules/operation'

const store = new Vuex.Store({
  modules: {
    user,
    customer,
    energetic,
    report,
    operation,
  },
})

export default store
